module.exports = __webpack_public_path__ + "static/media/BCH-BNB.b952334c.svg";